import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { ArticleCard } from "@/components/site/ArticleCard";
import { articles } from "@/lib/blog-data";

export const Route = createFileRoute("/blog/")({
  head: () => ({
    meta: [
      { title: "Ressources & inspirations — Blog Rénergescence" },
      { name: "description", content: "Articles sur la naturopathie, le bien-être, et nos partenaires sélectionnés avec soin." },
      { property: "og:title", content: "Blog — Rénergescence" },
      { property: "og:description", content: "Articles, conseils et partenaires." },
      { property: "og:url", content: "/blog" },
    ],
    links: [{ rel: "canonical", href: "https://renergescence.com/blog" }],
  }),
  component: BlogIndex,
});

const tags = ["Tous", "Naturopathie", "Énergie", "Partenaires", "Conseils"];

function BlogIndex() {
  const [active, setActive] = useState("Tous");
  const filtered = active === "Tous" ? articles : articles.filter((a) => a.category === active);

  return (
    <>
      <section className="pt-20 pb-12 md:pt-28">
        <div className="mx-auto max-w-3xl px-6 text-center">
          <p className="eyebrow">Le journal</p>
          <h1 className="mt-4 font-display text-5xl font-light italic md:text-7xl">Ressources & inspirations</h1>
          <p className="mt-6 text-base md:text-lg" style={{ color: "var(--color-muted-foreground)" }}>
            Articles sur la naturopathie, le bien-être, et nos partenaires sélectionnés avec soin.
          </p>
        </div>

        <div className="mx-auto mt-12 flex max-w-[1100px] flex-wrap justify-center gap-2 px-6">
          {tags.map((t) => (
            <button
              key={t}
              onClick={() => setActive(t)}
              className="rounded-full border px-5 py-2 text-sm transition-colors"
              style={{
                borderColor: active === t ? "var(--color-sage)" : "var(--color-border)",
                backgroundColor: active === t ? "var(--color-sage)" : "transparent",
                color: active === t ? "var(--color-background)" : "var(--color-text)",
              }}
            >
              {t}
            </button>
          ))}
        </div>
      </section>

      <section className="pb-24">
        <div className="mx-auto max-w-[1100px] px-6">
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {filtered.map((a) => (
              <ArticleCard
                key={a.slug}
                slug={a.slug}
                image={a.image}
                category={a.category}
                title={a.title}
                excerpt={a.excerpt}
                date={a.date}
                readTime={a.readTime}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
